import { PayloadAction } from "@reduxjs/toolkit";
import { addItemToCollection } from "./add-item-to-collection";
import { IActivityHistoryItem } from "../../domain/model";

export function addActivityHistoryItemReducer(
  state,
  action: PayloadAction<{
    id: string;
    item: IActivityHistoryItem;
    componentFactory: (item: IActivityHistoryItem) => HTMLElement;
  }>,
) {
  const { id, item, componentFactory } = action.payload;
  state.collections = addItemToCollection(state.collections, id, item, componentFactory);
}
